/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { CreateUploadFile } from '../model/createUploadFile';
import { FileDetails } from '../model/fileDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FileService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Upload pliku (backoffice)
     *  - __InputModelName__: CreateUploadFile - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: BackofficeCreateUploadFileHandler - __Name__:  - __Path__: /backoffice/core/files - __Method__: POST - __Description__:  - __Summary__: Upload pliku (backoffice) - __RouteName__: POSTFileDetailsHandler - __Hash__: 2f66051d57a332a954403d9c9576b4e2 - __Input__: SalesMailer\\Application\\Core\\UploadFile - __Output__: SalesMailer\\Domain\\Core\\File - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: FileDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public backofficeCreateUploadFileHandler(content?: CreateUploadFile, observe?: 'body', reportProgress?: boolean): Observable<FileDetails>;
    public backofficeCreateUploadFileHandler(content?: CreateUploadFile, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileDetails>>;
    public backofficeCreateUploadFileHandler(content?: CreateUploadFile, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileDetails>>;
    public backofficeCreateUploadFileHandler(content?: CreateUploadFile, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FileDetails>(`${this.basePath}/api/backoffice/core/files`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upload pliku
     *  - __InputModelName__: CreateUploadFile - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: CreateUploadFileHandler - __Name__:  - __Path__: /core/files - __Method__: POST - __Description__:  - __Summary__: Upload pliku - __RouteName__: POSTFileDetailsHandler - __Hash__: 5ffedd969e176e27911625d619e19184 - __Input__: SalesMailer\\Application\\Core\\UploadFile - __Output__: SalesMailer\\Domain\\Core\\File - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: FileDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUploadFileHandler(content?: CreateUploadFile, observe?: 'body', reportProgress?: boolean): Observable<FileDetails>;
    public createUploadFileHandler(content?: CreateUploadFile, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileDetails>>;
    public createUploadFileHandler(content?: CreateUploadFile, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileDetails>>;
    public createUploadFileHandler(content?: CreateUploadFile, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FileDetails>(`${this.basePath}/api/core/files`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Pobranie wybranego pliku
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileDownloadHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public fileDownloadHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public fileDownloadHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public fileDownloadHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fileDownloadHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/files/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
